// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3iqOS","label":"LabeledBox_label__3ALTS"};